import { render } from "./AccountantDashboard.vue?vue&type=template&id=4ecc7c5f&scoped=true"
import script from "./AccountantDashboard.vue?vue&type=script&lang=js"
export * from "./AccountantDashboard.vue?vue&type=script&lang=js"

import "./AccountantDashboard.vue?vue&type=style&index=0&id=4ecc7c5f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecc7c5f"]])

export default __exports__